<template>
  <div id="Banner">
    <div class="title">
      <img src="@/assets/images/talk/mention/ic-ic-talktalk.svg" />
      <span>오늘의 나우톡톡!</span>
    </div>
    <div class="box">
      <BannerTalk />
    </div>
  </div>
</template>

<script>
import BannerTalk from './BannerTalk'

export default {
  name: 'Banner',
  components: {
    BannerTalk
  }
}
</script>

<style lang="scss" scoped>
#Banner {
  width: 100%;
  box-sizing: border-box;
  float: left;
  display: block;
  margin-top: 25px;

  .title {
    @media screen and (max-width: 350px) {
      height: 20px;
    }
    @media screen and (min-width: 350px) {
      height: 25px;
    }
    img {
      float: left;
      width: auto;
      height: 100%;
    }
    span {
      float: left;
      line-height: 25px;
      font-weight: 900;
      color: #333333;
      margin-left: 7px;

      @media screen and (max-width: 350px) {
        font-size: 15px;
      }
      @media screen and (min-width: 350px) {
        font-size: 17px;
      }
    }
  }

  .box {
    box-sizing: border-box;
    width: 100%;
    max-height: 150px;
    display: block;
    float: left;
    position: relative;
    border-radius: 12px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    margin-top: calc(13vh / 647 * 100);

    @media screen and (max-width: 350px) {
      padding: 24px 21px;
    }
    @media screen and (min-width: 350px) {
      padding: 27px 24px;
    }
  }
}
</style>
